export const STATUS_LABELS = {
  new: "Nouveau",
  open: "Ouvert",
  waiting_user: "Attente utilisateur",
  waiting_internal: "Attente interne",
  resolved: "Résolu",
  closed: "Fermé",
};

export const GENERAL_CATEGORY_LABELS = {
  platform_usage: "Fonctionnement de la plateforme",
  technical: "Problème technique",
  account: "Mon compte",
  billing: "Paiement / facturation",
  other: "Autre",
};

export const DEAL_CATEGORY_LABELS = {
  edit_information: "Modifier des informations",
  deal_people: "Personnes liées au dossier",
  documents: "Documents",
  listing_distribution: "Annonce / diffusion",
  sale_in_progress: "Offre / vente en cours",
  close_deal: "Supprimer / clôturer le dossier",
  other: "Autre",
};

export const PERSON_CATEGORY_LABELS = {
  contact_details: "Modifier les coordonnées",
  personal_information: "Modifier les informations",
  access_connection: "Accès / connexion",
  deal_attachment: "Rattachement au dossier",
  other: "Autre",
};

export const CATEGORY_LABELS = {
  ...GENERAL_CATEGORY_LABELS,
  ...DEAL_CATEGORY_LABELS,
  ...PERSON_CATEGORY_LABELS,

  // Compatibilité d'affichage avec les tickets créés avant la refonte des sous-catégories.
  contact_error: "Email ou téléphone erroné",
  other_modification: "Autres modifications",
};

export function categoryLabelsForTopic(topicType) {
  if (topicType === "deal") return DEAL_CATEGORY_LABELS;
  if (topicType === "person") return PERSON_CATEGORY_LABELS;
  return GENERAL_CATEGORY_LABELS;
}

export function categoryLabel(category) {
  return CATEGORY_LABELS[category] || category || "—";
}

export function statusLabel(status) {
  return STATUS_LABELS[status] || status || "—";
}

export function formatDate(value) {
  if (!value) return "—";

  return new Intl.DateTimeFormat("fr-FR", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
}

export function userLabel(user) {
  if (!user) return "Personne";
  return [user.first_name, user.last_name].filter(Boolean).join(" ") || user.email || "Personne";
}

export function ticketContextLabel(ticket) {
  if (!ticket) return "";
  if (ticket.topic_type === "person") {
    return ticket.target_user ? `Personne — ${userLabel(ticket.target_user)}` : "Une personne en particulier";
  }
  if (ticket.deal) return `Dossier — ${ticket.deal.name || "sans nom"}`;
  return "Question générale";
}
